export const USER_ROLES = {
	OPTICAL: [ 'Ótica',
		'Optica',
		'Proprietário de Óptica',
		'Proprietario de Optica',
		'Gerente Ótica',
		'Gerente Optica'
	],
	LABORATORY: [ 'Laboratório', 'Laboratorio' ]
};
